<ng-template appAreaNotCovered></ng-template>
